<template>
    <a-modal
      title="创建小程序资产"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showAppForm"
      :confirmLoading="loading"
      class="app-result"
      @cancel="close"
    >
        <a-form-model
          ref="form"
          :model="model"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-spin :spinning="loading">
            <a-form-model-item label="工作台" prop="version_type" help="" >
              <a-radio-group v-model="model.version_type">
                <a-radio-button :value=1>旧版</a-radio-button>
                <a-radio-button :value=2 >升级版</a-radio-button>
              </a-radio-group>
            </a-form-model-item>

            <a-form-model-item label="小程序类型" prop="type">
              <a-select v-model="model.type" placeholder="小程序类型" @change="changeType" >
                <a-select-option :value="type.id" v-for="type in types" :key="type.id" >
                  {{ type.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>

            <a-form-model-item label="小程序类型" >
              <a-input value="短剧" disabled/>
            </a-form-model-item>

            <a-form-model-item label="细分分类" prop="tag_info" >
              <a-cascader :options="xcxNavs" v-model="model.tag_info"/>
            </a-form-model-item>

            <template v-if="model.type === 2 || model.type === 3 || model.type ===  5 || model.type ===  6  || model.type ===  7 || model.type === 9 || model.type === 10 || model.type === 12 || model.type === 13 || model.type === 14">
              <a-form-model-item label="小程序APP ID" prop="miniapp_username">
                <a-input v-model="model.miniapp_username"/>
              </a-form-model-item>
              <a-form-model-item label="小程序备注" prop="miniapp_name">
                <a-input v-model="model.miniapp_name"/>
               </a-form-model-item>
               <a-form-model-item v-if="model.version_type == 1" label="链接备注" prop="link_remark" help="可使用替换符 {剧名} 代替剧名 和 {日期} 代替日期">
                <a-input v-model="model.link_remark"/>
               </a-form-model-item>

             
            </template>

            <template v-else>
              <a-form-model-item label="小程序名称" prop="miniapp_name">
                <a-input v-model="model.miniapp_name"/>
              </a-form-model-item>
              <a-form-model-item label="小程序原始ID" prop="miniapp_username">
                <a-input v-model="model.miniapp_username"/>
              </a-form-model-item>

               <a-form-model-item v-if="model.version_type == 1" label="备注" prop="link_remark" help="可使用替换符 {剧名} 代替剧名 和 {日期} 代替日期">
                <a-input v-model="model.link_remark"/>
               </a-form-model-item>
            </template>
          

            <a-form-model-item label="短剧男女频" prop="playlet_gender" help="非必填，选择后，可以自动创建对应的商品" >
              <a-radio-group v-model="model.playlet_gender">
                <a-radio-button value="1">男频</a-radio-button>
                <a-radio-button value="2" >女频</a-radio-button>
                <a-radio-button value="3" >其他</a-radio-button>
              </a-radio-group>
            </a-form-model-item>
            
          </a-spin>
        </a-form-model>
        <div class="result" v-if="result.success.length + result.errors.length > 0">
          <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}-创建成功</div>
          <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index">{{ item }}</div>
        </div>
        <template slot="footer" >
          <a-button @click="close" :disabled="loading">取消</a-button>
          <a-button type="primary" @click="submit" :disabled="loading" v-if="result.success.length + result.errors.length <= 0">确定</a-button>
        </template>
    </a-modal>
</template>

<style lang="less" scoped>
@import 'CreateApp';
</style>

<script>
import CreateApp from './CreateApp'

export default CreateApp
</script>
